<template>
  <CCard>
    <CCardHeader>
      <strong>{{ this.$lang.dashboard.header.recent_pending_profile }}</strong>
      <span style="float: right;">
        <CBadge color="success">{{ count }}</CBadge>
      </span>
    </CCardHeader>
    <CCardBody>
      <CDataTable class="mb-0 table-outline" hover :items="tableItems" :fields="tableFields"
                  @row-clicked="rowClickHandler" head-color="light" no-sorting>
        <td slot="type" slot-scope="{ item }">
          <span :title="item.type">{{ trimfunction(item.type, 15) }}</span>
        </td>
        <td slot="company" slot-scope="{ item }">
          <span :title="item.company">{{ trimfunction(item.company, 15) }}</span>
        </td>
      </CDataTable>
      <CRow v-if="showProfile" style="margin-top: 2px">
        <CCol class="col-12 text-right">
          <button title="View All Profile" v-on:click="viewPendingProfiles" class="btn btn-light btn-block mb-1">
            View All
          </button>
        </CCol>
      </CRow>
    </CCardBody>
  </CCard>
</template>
<script>
import Vue from "vue";
import {ServerTable} from "vue-tables-2";
import store from "../../store/store";
import {Mixin} from "/src/mixins/index.js";
import {dashboardrecentPendingProfileList} from "../../store/url";

Vue.use(ServerTable, {}, false);
export default {
  name: "RecentPendingProfile",
  mixins: [Mixin],
  data() {
    return {
      self: this,
      count: 0,
      showProfile: false,
      moduleDashboardrecentPendingProfileList: dashboardrecentPendingProfileList,
      tableItems: [],
      tableFields: [
        {key: "type", label: this.$lang.dashboard.recentPendingProfile.type},
        {key: "company", label: this.$lang.dashboard.recentPendingProfile.company},
      ],
    };
  },
  mounted() {
    let self = this;
    store.commit("showLoader", false); // Loader Off
    axios.get(this.listUrlApi(this.moduleDashboardrecentPendingProfileList))
        .then((response) => {
          self.tableItems = response.data.data;
          self.count = response.data.count;
          if (response.data.data.length > 0) {
            self.showProfile = true;
          }
        });
  },
  methods: {
    rowClickHandler(item) {
      this.$router.push({path: `pending-profiles/view/${item.userId}`});
    },
    viewPendingProfiles() {
      this.$router.push({path: `pending-profiles`});
    },
  },
};
</script>
<style>
div .error {
  color: red;
}

.hasError label {
  color: red;
}
</style>
